import { useState, useEffect, useMemo } from 'react';
import { cn } from '../../lib/utils';
import { transCls } from '../../const/ui';
import { buildEntryTreeFromAliasMap } from './build-tree';
import { TreeItemNode } from './tree-item-node';
import type { IAppDetail } from '@baishuyun/types';
import type { BsEntrySelectChangeResult } from './types';
import { SolidArrowDownIcon } from '../bs-icons';

const ChevronRightIcon = ({ size }: { size?: number }) => (
  <SolidArrowDownIcon className="-rotate-90" size={size} />
);

export function OtherAppSection({
  appId,
  appDetail,
  searchQuery,
  selectedEntryId,
  section,
  onSelect,
}: {
  appId: string;
  appDetail: IAppDetail;
  searchQuery: string;
  selectedEntryId: string | undefined;
  section: 'current' | 'other';
  onSelect: (result: BsEntrySelectChangeResult) => void;
}) {
  const [expanded, setExpanded] = useState(true);
  const hasSearch = searchQuery.trim().length > 0;

  useEffect(() => {
    if (hasSearch) {
      setExpanded(true);
    }
  }, [hasSearch]);

  const tree = useMemo(() => {
    return buildEntryTreeFromAliasMap(appDetail, searchQuery);
  }, [appDetail, searchQuery, appDetail?.entryList?.length]);

  return (
    <div>
      <div
        className={cn(
          'flex items-center gap-[6px] h-[32px] cursor-pointer rounded-[4px] pr-[10px]',
          'hover:bg-[#EFF0F6]',
          transCls,
        )}
        style={{ paddingLeft: 15 }}
        onClick={() => setExpanded(!expanded)}
      >
        <span
          className={cn(
            'shrink-0 flex items-center justify-center w-[18px] h-[18px]',
            transCls,
            expanded && 'rotate-90',
          )}
        >
          <ChevronRightIcon size={18} />
        </span>
        <i
          className="node-icon icon-bsy-form icon-new-bsy-form-0"
          style={{ fontSize: 16, lineHeight: 1 }}
        />
        <span className="text-[14px] text-[#030303] truncate">
          {appDetail.name}
        </span>
      </div>
      {expanded && tree.length > 0 && (
        <div className="flex flex-col" style={{ paddingLeft: 15 }}>
          {tree.map((node) => (
            <TreeItemNode
              key={node.id}
              item={node}
              selectedEntryId={selectedEntryId}
              appId={appId}
              section={section}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
      {expanded && tree.length === 0 && hasSearch && (
        <div className="text-[12px] text-[#999999] py-[8px] pl-[32px]">
          无匹配结果
        </div>
      )}
      {expanded && tree.length === 0 && !hasSearch && (
        <div className="text-[12px] text-[#999999] py-[8px] pl-[32px]">
          暂无表单
        </div>
      )}
    </div>
  );
}
